/* GameEditorTitleRenderer.js */

'use strict';

class GameEditorTitleRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('game-editor-title-gl');
    this._rootElem.component = this._model;
    this._textEl = document.createElement('span');
    this.rootElement.appendChild(this._textEl);
    this._logger = this._model.logger;
    this._onActionIconClicked = this._onActionIconClicked.bind(this);
    this.render = this.render.bind(this);

    this._registerListeners();
  }
  /********************************************/
  /* START PRIVATE COMPONENT RENDERER METHODS */
  /********************************************/
  _registerListeners() {
    this.model.on('TitleChanged', this.render);
    this.model.on('showActionIconChanged', this.render);
  }
  _unregisterListeners() {
    this.model.removeAllListeners('TitleChanged');
  }
  /*******************************************/
  /* END PRIVATE COMPONENT RENDERER METHODS  */
  /* START PUBLIC COMPONENT RENDERER METHODS */
  /*******************************************/
  shutdown() {
    this._unregisterListeners();
    let promArr = [Promise.resolve()];

    return Promise.all(promArr).then(
      () => {
        this._removeActionIcon();
        this._model = undefined;
        this._rootElem.remove();
        this._rootElem = undefined;
      },
      (err) => {
        this._logger.warn(err, 'GameEditorTitleRenderer.shutdown error');
      }
    );
  }
  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */
  render() {
    return new Promise((resolve /*,reject*/) => {
      this._textEl.innerText = this.model.title;
      this._rootElem.style.display = this.model.isShown ? '' : 'none';
      if (this.model.showActionIcon) {
        //show icon if it isn't there already
        if (!this._actionIcon) {
          this._actionIcon = document.createElement(this.model.actionIconType);
          this._actionIcon.dataset.icon = this.model.actionIconName;
          this._actionIcon.dataset.darkTheme = true;
          this._actionIcon.setAttribute('title', this.model.actionIconTitle);
          this._actionIcon.addEventListener('click', this._onActionIconClicked);
          this._rootElem.appendChild(this._actionIcon);
        }
      } else {
        //remove icon if it exists
        this._removeActionIcon();
      }
      resolve();
    });
  }
  get rootElement() {
    return this.getRootElement();
  }
  getRootElement() {
    return this._rootElem;
  }
  get model() {
    return this.getModel();
  }
  getModel() {
    return this._model;
  }
  /*******************************************/
  /* END COMPONENT RENDERER METHODS */
  /* START PRIVATE RENDER METHODS */
  /*******************************************/
  _removeActionIcon() {
    if (this._actionIcon) {
      this._actionIcon.removeEventListener('click', this._onActionIconClicked);
      this._actionIcon.remove();
      this._actionIcon = undefined;
    }
  }
  /*******************************************/
  /* END PRIVATE RENDER METHODS */
  /* START HANDLER METHODS */
  /*******************************************/
  _onActionIconClicked() {
    this.model.onActionIconClicked();
  }
  /*******************************************/
  /* END HANDLER METHODS */
  /* START PRIVATE API METHODS */
  /*******************************************/

  /*******************************************/
  /*  END PRIVATE API METHODS */
  /*******************************************/
}
module.exports = GameEditorTitleRenderer;
